import SectionHeading from "@/components/feature/SectionHeading";
import ProcessSteps from "@/components/feature/ProcessSteps";
import { howItWorks } from "@/mocks/criacao-sites";

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Como funciona"
          badgeIcon="ri-route-line"
          badgeTone="accent"
          title="É simples começar"
          description="Do primeiro contato até a sua decisão, um processo claro e sem complicação."
        />
        <div className="mt-12">
          <ProcessSteps steps={howItWorks} />
        </div>
      </div>
    </section>
  );
}